/** Situações das Integrações */
export interface IntegracaoSituacao {
    id: number;
    nome: string;
}

export const situacaoAtiva: IntegracaoSituacao = {id: 1, nome: 'Ativa'};
export const situacaoInativa: IntegracaoSituacao = {id: 2, nome: 'Inativa'};


export const situacoesIntegracoes: IntegracaoSituacao[] = [
    situacaoAtiva,
    situacaoInativa
];

/** Verifica se a situação da integração é Ativa */
export function isSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === situacaoAtiva.id;
}

/** Verifica se a situação da integração é Inativa */
export function isSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === situacaoInativa.id;
}
